// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteEmployeeVisaMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type DeleteEmployeeVisaMutation = { __typename?: 'Mutation' } & Pick<Types.Mutation, 'deleteEmployeeVisa'>;

export const DeleteEmployeeVisaDocument = /*#__PURE__*/ gql`
    mutation deleteEmployeeVisa($id: ID!) {
  deleteEmployeeVisa(id: $id)
}
    `;
export type DeleteEmployeeVisaMutationFn = Apollo.MutationFunction<
  DeleteEmployeeVisaMutation,
  DeleteEmployeeVisaMutationVariables
>;

/**
 * __useDeleteEmployeeVisaMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeVisaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeVisaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeVisaMutation, { data, loading, error }] = useDeleteEmployeeVisaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeVisaMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeVisaMutation, DeleteEmployeeVisaMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEmployeeVisaMutation, DeleteEmployeeVisaMutationVariables>(
    DeleteEmployeeVisaDocument,
    options,
  );
}
export type DeleteEmployeeVisaMutationHookResult = ReturnType<typeof useDeleteEmployeeVisaMutation>;
export type DeleteEmployeeVisaMutationOptions = Apollo.BaseMutationOptions<
  DeleteEmployeeVisaMutation,
  DeleteEmployeeVisaMutationVariables
>;
